import type { Section } from '../types';

export type SectionItemSort = 'newest' | 'oldest';

export const DEFAULT_SECTION_ITEM_SORT: SectionItemSort = 'newest';

const SORT_COMMENT_RE = /^\s*<!--\s*dailylife:items=(newest|oldest)\s*-->\s*$/i;

export function sectionItemSort(section: Section): SectionItemSort {
  return section.itemSort ?? DEFAULT_SECTION_ITEM_SORT;
}

export function parseSectionItemSortComment(line: string): SectionItemSort | null {
  const m = SORT_COMMENT_RE.exec(line);
  if (!m) return null;
  return m[1]!.toLowerCase() as SectionItemSort;
}

export function serializeSectionItemSortComment(sort: SectionItemSort | undefined): string | null {
  const s = sort ?? DEFAULT_SECTION_ITEM_SORT;
  if (s === DEFAULT_SECTION_ITEM_SORT) return null;
  return `<!-- dailylife:items=${s} -->`;
}

/** Storage indices in UI display order (top → bottom). */
export function displayItemIndices(section: Section): number[] {
  const n = section.items.length;
  if (n === 0) return [];
  const indices = Array.from({ length: n }, (_, i) => i);
  if (sectionItemSort(section) === 'oldest') indices.reverse();
  return indices;
}

export function toggleSectionItemSort(section: Section): SectionItemSort {
  const next: SectionItemSort = sectionItemSort(section) === 'newest' ? 'oldest' : 'newest';
  section.itemSort = next;
  return next;
}

export function sectionItemSortMenuLabel(section: Section): string {
  return sectionItemSort(section) === 'newest' ? '↓ Oldest first' : '↑ Newest first';
}
